<template>
  <div class="inline">
    <icon-female class="mx-1 ml-0" />
    <span class="text-chplus-regular" :class="{ 'text-white': highlight }">{{
      people.length === 0
        ? "-"
        : asPercent
        ? ((genderCount[1] / people.length) * 100).toFixed(0) + "%"
        : genderCount[1]
    }}</span>
    <icon-male class="mx-1" />
    <span class="text-chplus-regular" :class="{ 'text-white': highlight }">{{
      people.length === 0
        ? "-"
        : asPercent
        ? ((genderCount[0] / people.length) * 100).toFixed(0) + "%"
        : genderCount[0]
    }}</span>
  </div>
</template>

<script>
import IconFemale from "@/components/icons/IconFemale";
import IconMale from "@/components/icons/IconMale";

export default {
  name: "GenderDistribution",
  components: { IconMale, IconFemale },
  props: {
    people: {
      type: Array,
      required: true
    },
    asPercent: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    genderCount() {
      let count = this.people.reduce(
        (count, person) => {
          if (person.gender == "m") {
            count[0]++;
          } else {
            count[1]++;
          }
          return count;
        },
        [0, 0]
      );
      return count;
    }
  }
};
</script>
